var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChina1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "china 1",
    clipPath: "url(#clip0_1626_243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "China"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5055 8.68456L10.769 8.67256L10.5295 7.97656L10.2905 8.67256L9.55402 8.68506L10.1425 9.12706L9.92702 9.83056L10.53 9.40806L11.133 9.83056L10.917 9.12706L11.5055 8.68456Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.80452 5.36411L8.81652 4.62761L9.51252 4.38811L8.81652 4.14861L8.80402 3.41211L8.36202 4.00061L7.65802 3.78561L8.08102 4.38861L7.65802 4.99161L8.36202 4.77511L8.80452 5.36411Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.80452 11.5887L8.81652 10.8522L9.51252 10.6127L8.81652 10.3732L8.80402 9.63672L8.36202 10.2252L7.65802 10.0102L8.08102 10.6132L7.65802 11.2162L8.36202 10.9997L8.80452 11.5887Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.8265 6.26847L11.1495 5.60697L10.488 5.92997L9.95852 5.41797L10.062 6.14647L9.41202 6.49197L10.1375 6.61947L10.265 7.34497L10.6095 6.69447L11.3385 6.79747L10.8265 6.26847Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.75551 6.60822L4.77001 6.57522L4.12451 4.69922L3.47951 6.57572L1.49451 6.60922L3.08101 7.80172L2.50001 9.69922L4.12551 8.55972L5.75151 9.69822L5.16951 7.80122L6.75551 6.60822Z",
    fill: "#FFFF00"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina1);
export default __webpack_public_path__ + "static/media/china 1.80bba2e4a7b308bb80ca4b1a8321b1f2.svg";
export { ForwardRef as ReactComponent };